import { AbstractControl, FormArray } from '@angular/forms';

/**
 * Ensures a FormArray has at least one item by adding a new one if empty.
 * @param formArray - The FormArray to check
 * @param factory - Factory function to create a new form control/group
 */
export function ensureAtLeastOne<T extends AbstractControl<any, any>>(formArray: FormArray<T>, factory: () => T): void {
  if (formArray.length === 0) {
    formArray.push(factory());
  }
}
